import { Col, Row } from "antd";
import React from "react";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import AdnCard from "../common/adnCard/AdnCard";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import { StatusOptions } from "../common/GeneralConfigurations";
import { useTranslation } from "react-i18next";
import "./UserListForm.css";

export const UserListForm = ({
  title,
  name,
  currPage,
  totalRecords,
  handleChangePage,
  users,
  columns,
  addUser,
  handleOrderList,
  namePlaceholder,
  handleSearchName,
  handleStatus,
  handleSelectName,
  nameList,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard loading={loading}>
        <Row gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 8 }}
            xl={{ span: 5 }}
            xxl={{ span: 5 }}
          >
            <AdnAutoComplete
              placeholder={namePlaceholder}
              handleSearch={handleSearchName}
              handleSelect={handleSelectName}
              resultList={nameList}
              valueId="name"
            />
          </Col>
          <Col
            className="userStatusFilter"
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 8 }}
            xl={{ span: 5 }}
            xxl={{ span: 5 }}
          >
            <AdnDropdown
              placeholder={t("user.placeholders.status")}
              handleChange={handleStatus}
              options={StatusOptions}
              allowClear
            />
          </Col>
          {/*<Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 14 }} xxl={{ span: 14 }}>*/}
          {/*  <AdnAddButton*/}
          {/*    style={{ float: 'right' }}*/}
          {/*    handleClick={addUser}*/}
          {/*    name={name}*/}
          {/*  />*/}
          {/*</Col>*/}
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <AdnTable
              columns={columns}
              data={users}
              currentPage={currPage}
              totalRecords={totalRecords}
              handleChangePage={handleChangePage}
              handleChange={handleOrderList}
            />
          </Col>
        </Row>
      </AdnCard>
    </>
  );
};
